import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { LogoutRequest } from 'src/app/pages/auth/login/models/logoutRequest';
import { of } from 'rxjs'; // Add this at the top
@Injectable({
  providedIn: 'root',
})
export class UserService {
  screenSize: string = '';

  constructor(private auth: AuthService) { }

  isKeyValid() {
    return localStorage.getItem('gptKeyValid') === 'true';
  }

  setUserInfo(user: any) {
    localStorage.setItem('userInfo', JSON.stringify(user));
  }

  deleteUserInfo() {
    localStorage.removeItem('userInfo');
  }

  getUserInfo() {
    return localStorage.getItem('userInfo');
  }

  storeGPTKey(gptKey: any) {
    localStorage.setItem('gptKey', gptKey);
    localStorage.setItem('gptKeyValid', 'true');
  }
  getGPTKey() {
    return localStorage.getItem('gptKey');
  }

  deleteGPTKey() {
    localStorage.removeItem('gptKey');
  }

  getUserImage() {
    let userInfo = this.getUserInfo();

    if (userInfo) {
      let userObject = JSON.parse(userInfo);
      if (!userInfo.includes('Guest User')) {
        return userObject.picture;
      }
    }
    return 'assets/default-avatar.jpg';
  }

  setTokenInfo(
    accessToken: string,
    refreshToken: string,
    userId: string,
    role: string
  ) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('userId', userId);
    localStorage.setItem('role', role);
  }

  setAccessToken(newToken: string) {
    localStorage.setItem('accessToken', newToken);
  }

  deleteTokenInfo() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
  }

  deleteAccessToken() {
    localStorage.removeItem('accessToken');
  }

  getAcessToken() {
    return localStorage.getItem('accessToken');
  }

  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  getUserId() {
    return localStorage.getItem('userId');
  }

  isUserLogin() {
    if (this.getAcessToken() === null) return false;
    if (this.refreshToken() === null) return false;
    return true;
  }

  async logInAsGuest() {
    let userInfo = this.collectUserInfo();
    this.auth.loginWithGoogle(userInfo).subscribe(
      (response: any) => {
        this.setTokenInfo(
          response.accessToken,
          response.refreshToken,
          response.userId,
          response.role
        );
      },
      (error: any) => {

      }
    );
  }

  async logInWithGoogleAccount(user: any) {
    this.auth.loginWithGoogle(user).subscribe(
      (response: any) => {
        this.setTokenInfo(
          response.accessToken,
          response.refreshToken,
          response.userId,
          response.role
        );
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      },
      (error: any) => {
        setTimeout(() => {
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }, 3000);
      }
    );
  }

  logoutFromGoogleAccount() {
    let logoutParams: any = {};
    if (typeof document !== 'undefined') {
      logoutParams = { returnTo: document.location.origin };
    }

    this.auth.logoutFromGoogle({ logoutParams });

    const refreshToken = this.getRefreshToken();
    localStorage.clear();

    if (refreshToken) {
      const logoutRequest: LogoutRequest = { refreshToken };
      return this.auth.logoutFromGoogle(logoutRequest); // still returns the expected Observable
    }

    return of(null); // ✅ Ensures a value is returned in all paths
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    if (refreshToken) {
      const logoutRequest: LogoutRequest = { refreshToken: refreshToken };
      return this.auth.refreshAccessToken(logoutRequest);
    } else return new BehaviorSubject(null);
  }

  getScreenSize() {
    return this.screenSize;
  }

  setScreenSize(screenSize: string) {
    this.screenSize = screenSize;
  }

  collectUserInfo() {
    let userSource = 'Direct';
    if (typeof document !== 'undefined') {
      userSource = document.referrer || 'Direct';
    }

    let userInfo = {
      screenSize: this.getScreenSizeAsString(),
      operatingSystem: this.getOperatingSystem(),
      userSource
    };

    return userInfo;
  }

  private getScreenSizeAsString(): string {
    let width = 0;
    let height = 0;

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      width =
        window.innerWidth ||
        document.documentElement?.clientWidth ||
        document.body?.clientWidth ||
        0;

      height =
        window.innerHeight ||
        document.documentElement?.clientHeight ||
        document.body?.clientHeight ||
        0;
    }

    return width + ' X ' + height;
  }



  private getOperatingSystem(): string {
    let userAgent = "";

    if (typeof window !== 'undefined') {
      const userAgent = window.navigator.userAgent;
    }

    switch (true) {
      case /Windows/.test(userAgent):
        return 'Windows';
      case /Mac/.test(userAgent):
        return 'Mac OS';
      case /iPhone|iPad/.test(userAgent):
        return 'iOS';
      case /Android/.test(userAgent):
        return 'Android';
      case /Linux/.test(userAgent):
        return 'Linux';
      case /CrOS/.test(userAgent):
        return 'Chrome OS';
      case /Windows Phone/.test(userAgent):
        return 'Windows Phone';
      default:
        return 'Unknown';
    }
  }
}
